import { QUERY_LIST_SCHEDULED_CHAT_MESSAGES } from '@/graphql/query.graphql';
import { useChatMessageScheduleStatusSubscription } from '@/types/generated/graphql';
import { useApolloClient } from '@apollo/client';

// The scheduler changing one of this member's schedules — sent, retried or failed — server-side. Apollo
// has already merged the row, so an open modal shows the new status; the refetch settles list
// membership and the pending / failed badges for that room.
export function useScheduleStatusSubscription() {
  const client = useApolloClient();

  useChatMessageScheduleStatusSubscription({
    onData: ({ data }) => {
      const roomId = data.data?.chatMessageSchedule?.roomId;
      if (!roomId) return;

      client.query({ query: QUERY_LIST_SCHEDULED_CHAT_MESSAGES, variables: { roomId }, fetchPolicy: 'network-only' });
    },
  });
}
